const Deal = require('./Deal');
const { DEAL_STATUS } = require('../constants/DealConstants');

function dealSupplierExtractor(deal) {
  const deal_id = deal && deal.id;
  if (!deal_id) {
    return {};
  }
  let supplier = deal_id.substr(0, 1);// backward compatible
  const splitted = deal_id.split(':');
  const supplier_hub_code = deal.supplier_hub_code;
  if (splitted.length > 1) {
    supplier = splitted[0];
  }
  if (supplier === 'H') {// backward compatible
    supplier = 'HB';
  }
  return { supplier, supplier_hub_code };
}

function isValidDeal(deal) {
  if (!deal || !deal.id) {
    //console.error('invalid deal received: ', deal);
    return false;
  }
  return true;
}

function isValidRecheck(recheck) {
  return recheck && recheck.recheck_id && recheck.chooseprod && recheck.cheapopoPricing;
}

function createDeal(deal, idx) {
  return new Deal(deal, idx + 1); // 1 based
}

function createDeals(deals) {
  if (!Array.isArray(deals)) {
    // console.error('invalid deals received: ', deals);
    return [];
  }

  return deals.filter(isValidDeal).map(createDeal);
}

function updateDealRecheck(deal, recheck) {
  deal.setRecheck(recheck.recheck_id, recheck.chooseprod, recheck.cheapopoPricing, recheck.installments_eligibility);
  deal.status = DEAL_STATUS.SUCCESS;
  if (deal.error) {
    deal.error = false;
  }
  return deal;
}

function compareByPrice(dealA, dealB) {
  return dealA.totalPrice - dealB.totalPrice;
}

module.exports = {
  dealSupplierExtractor,
  isValidDeal,
  isValidRecheck,
  createDeal,
  createDeals,
  updateDealRecheck,
  compareByPrice
};
